<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width=".7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M12 7 L11 10 L13 12 L11 14 L12.5 17 L11.5 19" />
  </svg>
</template>

<script>
export default { name: 'IconHeartCrack' };
</script>
